var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2, _rect3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#472593;}.cls-2{fill:#783df5;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 159.21,
    y1: 89.58,
    x2: 44.36,
    y2: 155.41,
    gradientTransform: "translate(-6.03 18.81) scale(1.05 1.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#472593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4b2a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6545ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7456e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7a5cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8567f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a184fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ac8ffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.98,
    y1: 136.6,
    x2: 59.1,
    y2: 136.05,
    gradientTransform: "translate(37.61 5.05) scale(1 1.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#472593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5029a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#6735d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#783df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8d5ff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9e79fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a889fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ac8ffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a284fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8668f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7a5cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#785aef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#7352e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6b44d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5e31c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5e31c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 112.99,
    y1: 142.95,
    x2: 67.22,
    y2: 143.19,
    gradientTransform: "translate(33.46 1.08) scale(1 0.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7a5cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8567f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9b7dfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a88bfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ac8ffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9c76fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#783df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6e38e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#592eb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4c279d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#472593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 498.36,
    y1: 59.92,
    x2: 536.71,
    y2: 44.21,
    gradientTransform: "translate(679.85 234.31) rotate(176.39)",
    xlinkHref: "#linear-gradient-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.55,150l-1.72-5.75H225.55L223.83,150H210.42l14.89-40.79h15.24L255.43,150Zm-13.28-14.88h8.84l-4.27-14.53h-.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.93,150V107h11.8v43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.68,150V107h11.8v43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.42,115v-8h11.8v8Zm0,35V118.69h11.8V150Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.46,150l-.77-4.74a12.67,12.67,0,0,1-4.84,4,14.23,14.23,0,0,1-6.31,1.45c-3.64,0-6.36-1-8.18-3s-2.73-4.92-2.73-8.72V118.69h11.8v18.86a4.82,4.82,0,0,0,1,3.23A3.65,3.65,0,0,0,334.4,142a4.7,4.7,0,0,0,3.56-1.43,4.85,4.85,0,0,0,1.36-3.5V118.69h11.8V150Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.87,121c1.77,2,2.67,4.94,2.67,8.69V150H398.73V131.15a5,5,0,0,0-1-3.24A3.36,3.36,0,0,0,395,126.7a4.36,4.36,0,0,0-3.38,1.42,5,5,0,0,0-1.3,3.5V150h-11.8V131.15a5,5,0,0,0-1-3.24,3.36,3.36,0,0,0-2.76-1.21,4.37,4.37,0,0,0-3.38,1.42,5,5,0,0,0-1.3,3.5V150H358.3V118.69H368l.77,4.69a12.57,12.57,0,0,1,4.71-3.95,13.94,13.94,0,0,1,6.2-1.45q7.07,0,9.49,5.4a13.14,13.14,0,0,1,4.71-3.95,13.28,13.28,0,0,1,6-1.45Q405.2,118,407.87,121Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.09,195.17V170.75h1.78v24.42Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.72,176.82a8.54,8.54,0,0,1,3.89.85,6,6,0,0,1,2.57,2.59,8.9,8.9,0,0,1,.93,4.27v10.64h-1.74v-10.5a6.45,6.45,0,0,0-1.56-4.68,5.74,5.74,0,0,0-4.34-1.6,7.52,7.52,0,0,0-3.7.87,5.91,5.91,0,0,0-2.39,2.44,8.13,8.13,0,0,0-.81,3.77v9.7h-1.75V177h1.67V182l-.24-.56a6.91,6.91,0,0,1,2.76-3.4A8.48,8.48,0,0,1,232.72,176.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.3,178.46V177h10.88v1.5Zm8.3,16.85a4.86,4.86,0,0,1-3.68-1.33,5,5,0,0,1-1.28-3.63V173h1.75v17.2a3.79,3.79,0,0,0,.87,2.68,3.25,3.25,0,0,0,2.51.95,4,4,0,0,0,2.82-1l.74,1.22a4.26,4.26,0,0,1-1.69,1A6.79,6.79,0,0,1,252.6,195.31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.91,195.31a9.79,9.79,0,0,1-4.87-1.19,8.55,8.55,0,0,1-3.31-3.28,9.43,9.43,0,0,1-1.2-4.78,9.77,9.77,0,0,1,1.13-4.79,8.37,8.37,0,0,1,3.12-3.26,9.07,9.07,0,0,1,8.91,0,8.11,8.11,0,0,1,3.1,3.23,9.78,9.78,0,0,1,1.14,4.79.93.93,0,0,1,0,.23,2.11,2.11,0,0,0,0,.26H259.81v-1.36H275l-.69.66a7.7,7.7,0,0,0-.89-3.82,7,7,0,0,0-2.5-2.65,6.93,6.93,0,0,0-9.73,2.65,8.12,8.12,0,0,0-.91,3.86v.31a7.82,7.82,0,0,0,1,4,7,7,0,0,0,2.74,2.69,8.07,8.07,0,0,0,4,1,8.38,8.38,0,0,0,3.26-.63,6.41,6.41,0,0,0,2.57-1.92l1,1.15a7.49,7.49,0,0,1-3,2.22A10,10,0,0,1,267.91,195.31Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.33,195.17V177H283v5l-.17-.56a6.43,6.43,0,0,1,2.57-3.38,8.16,8.16,0,0,1,4.54-1.19v1.71l-.21,0h-.21a6,6,0,0,0-4.74,1.9,7.59,7.59,0,0,0-1.71,5.28v9.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.66,176.82a8.51,8.51,0,0,1,3.89.85,6,6,0,0,1,2.58,2.59,9,9,0,0,1,.92,4.27v10.64h-1.74v-10.5a6.45,6.45,0,0,0-1.56-4.68,5.74,5.74,0,0,0-4.34-1.6,7.48,7.48,0,0,0-3.69.87,5.8,5.8,0,0,0-2.39,2.44,8,8,0,0,0-.82,3.77v9.7h-1.75V177h1.68V182l-.25-.56a6.91,6.91,0,0,1,2.76-3.4A8.48,8.48,0,0,1,303.66,176.82Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.15,195.31a8.71,8.71,0,0,1-3.5-.65,5,5,0,0,1-2.27-1.83,4.84,4.84,0,0,1-.78-2.72,5,5,0,0,1,.64-2.53,4.68,4.68,0,0,1,2.15-1.85,9.36,9.36,0,0,1,4-.71h6.7v1.36h-6.67c-1.88,0-3.2.35-3.95,1a3.41,3.41,0,0,0-1.14,2.62,3.37,3.37,0,0,0,1.33,2.79,5.85,5.85,0,0,0,3.73,1,6.91,6.91,0,0,0,3.89-1,6.2,6.2,0,0,0,2.35-3l.49,1.19a6.33,6.33,0,0,1-2.49,3.16A8,8,0,0,1,323.15,195.31Zm6.56-.14V191l-.07-.63v-6.84a5.12,5.12,0,0,0-1.38-3.87,5.61,5.61,0,0,0-4-1.32,9.5,9.5,0,0,0-6.27,2.3l-.88-1.26a9.72,9.72,0,0,1,3.28-1.9,12,12,0,0,1,4-.68,7.29,7.29,0,0,1,5.2,1.71,6.67,6.67,0,0,1,1.82,5.09v11.55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.57,178.46V177h10.88v1.5Zm8.3,16.85a4.89,4.89,0,0,1-3.68-1.33,5,5,0,0,1-1.27-3.63V173h1.74v17.2a3.75,3.75,0,0,0,.88,2.68,3.23,3.23,0,0,0,2.51.95,4,4,0,0,0,2.82-1l.73,1.22a4.19,4.19,0,0,1-1.69,1A6.69,6.69,0,0,1,343.87,195.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.32,172.53a1.38,1.38,0,0,1-1-.42,1.33,1.33,0,0,1-.42-1,1.38,1.38,0,0,1,.42-1,1.41,1.41,0,0,1,1-.41,1.39,1.39,0,0,1,1,.4,1.34,1.34,0,0,1,.41,1,1.4,1.4,0,0,1-.41,1A1.36,1.36,0,0,1,353.32,172.53Zm-.87,22.64V177h1.75v18.21Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.67,195.31a9.1,9.1,0,0,1-4.66-1.19,8.72,8.72,0,0,1-3.24-3.28,10.14,10.14,0,0,1,0-9.57A8.74,8.74,0,0,1,364,178a9.74,9.74,0,0,1,9.33,0,8.69,8.69,0,0,1,3.25,3.26,10.29,10.29,0,0,1,0,9.57,8.68,8.68,0,0,1-3.25,3.28A9.19,9.19,0,0,1,368.67,195.31Zm0-1.57a7.44,7.44,0,0,0,3.77-1,6.68,6.68,0,0,0,2.61-2.71,9,9,0,0,0,0-8,6.73,6.73,0,0,0-2.61-2.68,7.44,7.44,0,0,0-3.77-1,7.37,7.37,0,0,0-3.75,1A7,7,0,0,0,362.3,182a9,9,0,0,0,0,8,6.9,6.9,0,0,0,2.62,2.71A7.37,7.37,0,0,0,368.67,193.74Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.07,176.82a8.48,8.48,0,0,1,3.89.85,5.92,5.92,0,0,1,2.58,2.59,8.9,8.9,0,0,1,.93,4.27v10.64h-1.75v-10.5a6.49,6.49,0,0,0-1.55-4.68,5.74,5.74,0,0,0-4.34-1.6,7.52,7.52,0,0,0-3.7.87,5.91,5.91,0,0,0-2.39,2.44,8.13,8.13,0,0,0-.82,3.77v9.7h-1.74V177h1.67V182l-.24-.56a6.89,6.89,0,0,1,2.75-3.4A8.48,8.48,0,0,1,392.07,176.82Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.57,195.31a8.76,8.76,0,0,1-3.51-.65,5.05,5.05,0,0,1-2.26-1.83,4.77,4.77,0,0,1-.79-2.72,5,5,0,0,1,.65-2.53,4.65,4.65,0,0,1,2.14-1.85,9.39,9.39,0,0,1,4-.71h6.7v1.36h-6.66c-1.89,0-3.2.35-4,1a3.61,3.61,0,0,0,.19,5.41,5.89,5.89,0,0,0,3.73,1,6.89,6.89,0,0,0,3.89-1,6.16,6.16,0,0,0,2.36-3l.49,1.19a6.3,6.3,0,0,1-2.5,3.16A7.94,7.94,0,0,1,411.57,195.31Zm6.56-.14V191l-.07-.63v-6.84a5.12,5.12,0,0,0-1.38-3.87,5.61,5.61,0,0,0-4-1.32,9.56,9.56,0,0,0-6.28,2.3l-.87-1.26a9.72,9.72,0,0,1,3.28-1.9,12,12,0,0,1,4-.68,7.29,7.29,0,0,1,5.2,1.71,6.67,6.67,0,0,1,1.81,5.09v11.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M427,195.17V169.29h1.74v25.88Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445.61,195.17V170.75h1.78v22.81h14.05v1.61Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M466.33,172.53a1.37,1.37,0,0,1-1-.42,1.33,1.33,0,0,1-.42-1,1.38,1.38,0,0,1,.42-1,1.49,1.49,0,0,1,2,0,1.33,1.33,0,0,1,.4,1,1.39,1.39,0,0,1-.4,1A1.36,1.36,0,0,1,466.33,172.53Zm-.87,22.64V177h1.74v18.21Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.23,176.82a8.18,8.18,0,0,1,3.82.85,6,6,0,0,1,2.53,2.59,9.15,9.15,0,0,1,.91,4.27v10.64h-1.75v-10.5a6.61,6.61,0,0,0-1.5-4.68,5.44,5.44,0,0,0-4.19-1.6,6.94,6.94,0,0,0-3.55.87,5.82,5.82,0,0,0-2.3,2.44,8.13,8.13,0,0,0-.81,3.77v9.7h-1.74v-10.5a6.61,6.61,0,0,0-1.5-4.68,5.45,5.45,0,0,0-4.18-1.6,6.93,6.93,0,0,0-3.56.87,5.91,5.91,0,0,0-2.31,2.44,8.26,8.26,0,0,0-.8,3.77v9.7h-1.74V177h1.67v5l-.24-.56a6.79,6.79,0,0,1,2.68-3.36,8.06,8.06,0,0,1,4.54-1.24,7.53,7.53,0,0,1,4.59,1.38,6.23,6.23,0,0,1,2.35,4.1l-.59-.25a7.09,7.09,0,0,1,2.75-3.78A8.21,8.21,0,0,1,497.23,176.82Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.54,172.53a1.38,1.38,0,0,1-1-.42,1.33,1.33,0,0,1-.42-1,1.38,1.38,0,0,1,.42-1,1.41,1.41,0,0,1,1-.41,1.39,1.39,0,0,1,1,.4,1.33,1.33,0,0,1,.4,1,1.39,1.39,0,0,1-.4,1A1.36,1.36,0,0,1,512.54,172.53Zm-.87,22.64V177h1.74v18.21Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.77,178.46V177h10.89v1.5Zm8.3,16.85a4.89,4.89,0,0,1-3.68-1.33,5,5,0,0,1-1.27-3.63V173h1.74v17.2a3.75,3.75,0,0,0,.88,2.68,3.23,3.23,0,0,0,2.51.95,4,4,0,0,0,2.82-1l.74,1.22a4.23,4.23,0,0,1-1.7,1A6.69,6.69,0,0,1,526.07,195.31Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.39,195.31a9.79,9.79,0,0,1-4.87-1.19,8.55,8.55,0,0,1-3.31-3.28,9.43,9.43,0,0,1-1.21-4.78,9.78,9.78,0,0,1,1.14-4.79,8.3,8.3,0,0,1,3.12-3.26,8.53,8.53,0,0,1,4.46-1.19,8.63,8.63,0,0,1,4.45,1.15,8.17,8.17,0,0,1,3.1,3.23,9.78,9.78,0,0,1,1.14,4.79,2,2,0,0,1,0,.23,2.11,2.11,0,0,0,0,.26H533.29v-1.36h15.14l-.7.66a7.49,7.49,0,0,0-.89-3.82,6.91,6.91,0,0,0-2.49-2.65,6.92,6.92,0,0,0-9.73,2.65,8,8,0,0,0-.91,3.86v.31a7.72,7.72,0,0,0,1,4,7,7,0,0,0,2.73,2.69,8.14,8.14,0,0,0,4,1,8.42,8.42,0,0,0,3.26-.63,6.48,6.48,0,0,0,2.57-1.92l1,1.15a7.46,7.46,0,0,1-3,2.22A9.94,9.94,0,0,1,541.39,195.31Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.82,195.31a9,9,0,0,1-4.58-1.17,8.57,8.57,0,0,1-3.23-3.26,10.38,10.38,0,0,1,0-9.65,8.59,8.59,0,0,1,3.23-3.24,9,9,0,0,1,4.58-1.17,8.49,8.49,0,0,1,4.35,1.12,8.08,8.08,0,0,1,3.07,3.17,10.17,10.17,0,0,1,1.13,4.95,10.33,10.33,0,0,1-1.12,4.92,7.82,7.82,0,0,1-3,3.21A8.65,8.65,0,0,1,561.82,195.31Zm.11-1.57a7.37,7.37,0,0,0,3.75-1,6.88,6.88,0,0,0,2.61-2.71,8.9,8.9,0,0,0,0-8,6.93,6.93,0,0,0-2.61-2.68,7.8,7.8,0,0,0-7.5,0,7,7,0,0,0-2.62,2.68,8.9,8.9,0,0,0,0,8,6.9,6.9,0,0,0,2.62,2.71A7.32,7.32,0,0,0,561.93,193.74Zm7.36,1.43v-6l.31-3.17-.35-3.18V169.29H571v25.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.39,
    y: 68.72,
    width: 46.08,
    height: 147.86,
    rx: 23.04,
    transform: "translate(18.97 -11.62) rotate(7.31)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.75,
    y: 70.81,
    width: 44.04,
    height: 152.34,
    rx: 20.08,
    transform: "translate(-51.64 40.11) rotate(-23)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.6,
    y: 62.13,
    width: 44.04,
    height: 127.72,
    rx: 20.08,
    transform: "translate(-39.4 58.31) rotate(-23)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 161.15,
    cy: 214.42,
    r: 20.71
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllium);
export default __webpack_public_path__ + "static/media/Allium.d6a072a76efde7581c384fe50e6aa887.svg";
export { ForwardRef as ReactComponent };